<template>
    <b-modal
            id="edit-session-notes-modal"
            :title="title"
            v-model="showModal"
            centered no-close-on-backdrop
            @ok="handleOk"
            @cancel="handleCancel"
            @close="handleCancel">
        <b-overlay :show="isLoading" rounded="sm">

            <ErrorView :visible="isLoadingError" :errorValue="loadingErrorValue"/>

            <form v-if="isLoadingError == false" ref="form" v-on:submit.prevent="noop">
                <b-form-group
                        label="Notes"
                        label-for="notes-input"
                        invalid-feedback="(maximum 2000 characters)"
                        :state="notesState">
                    <b-form-textarea
                            id="notes-input"
                            placeholder="Enter notes"
                            v-model="notesValue"
                            rows="10"
                            max-rows="10"
                            >
                    </b-form-textarea>
                </b-form-group>

            </form>
        </b-overlay>
        <template v-slot:modal-footer="{ ok, cancel }">
            <b-button size="sm" variant="primary" @click="ok()">
                Save Changes
            </b-button>
            <b-button size="sm" variant="outline-secondary" @click="cancel()">
                Cancel
            </b-button>
        </template>

        <b-modal id="error-modal" size="sm" title="Action failed" ok-only centered>
            <p class="m-2">There was a problem completing the action, Please try again.</p>
        </b-modal>

    </b-modal>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import ErrorView from '../ErrorView'

    export default {
        name: "SessionNotesModal",
        components: {
            ErrorView
        },
        data() {
            return {
                showModal: false,

                title: "-",

                notesValue: null,
                showValidation: false,
            }
        },
        watch: {
            model(newValue) {
                this.resetModel(newValue);
            },
            showModal(newValue) {
                if(newValue) this.resetModel(this.model);
            }
        },
        computed: {
            ...mapGetters({
                model: 'session/current',
                isModelLoading: 'session/currentLoading',
                isModelLoadingError: 'session/currentLoadingError',
                modelLoadingErrorValue: 'session/currentLoadingErrorValue',
            }),

            isLoading: function() {
                return this.isModelLoading;
            },
            isLoadingError: function() {
                return this.isModelLoadingError;
            },
            loadingErrorValue: function() {
                return this.modelLoadingErrorValue;
            },

            notesState: function () {
                if (!this.notesValue || (this.notesValue && this.notesValue.length < 2000)) {
                    return true
                }
                return this.showValidation ? false : null
            },
            validatedValue: function() {

                if(this.notesState) {
                    let value = {
                        sessionId: this.model ? this.model.sessionId : undefined,
                        organizationId: this.model ? this.model.organizationId : undefined,
                        notes: this.notesValue ?? "",
                    };

                    return value;
                }

                return null;
            },
        },
        methods: {
            ...mapActions({
                save: 'session/save',
            }),
            resetModel(newValue) {
                this.showValidation = false;
                if (newValue) {
                    this.title = "Edit Session Notes"
                    this.notesValue = newValue.notes;
                } else {
                    this.title = "-"
                    this.notesValue = null;
                }
            },
            handleOk(bvModalEvt) {

                // Prevent modal from closing
                bvModalEvt.preventDefault()

                if (this.isLoading) {
                    return
                }

                if (this.validatedValue != null) {

                    let self = this;
                    this.save(this.validatedValue)
                        .then(function (success) {
                            if(success) {
                                self.resetModel(null);
                                self.closeModal();
                            } else {
                                self.$bvModal.show('error-modal')
                            }
                        })

                } else {
                    this.showValidation = true;
                }
            },
            handleCancel(bvModalEvt) {
                // Prevent modal from closing
                bvModalEvt.preventDefault()

                if (this.isLoading) {
                    return
                }

                this.closeModal()

            },
            closeModal() {
                this.$nextTick(() => {
                    this.$bvModal.hide('edit-session-notes-modal')
                })
            }
        }
    }
</script>

<style scoped>

</style>